import { AngularFireStorage } from '@angular/fire/storage';
import { Injectable } from '@angular/core';

import { AngularFireDatabase, AngularFireList } from '@angular/fire/database';
import { Observable, combineLatest } from 'rxjs';
import { finalize, map, tap } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/firestore';
import { Endpoints } from 'src/app/core/resources/endpoints';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { MerchandiseCodes } from 'src/app/core/enums/merchandiseCodes.enum';
import { MerchandiseType } from 'src/app/core/interfaces/merchandiseType';
import { CatalogItem } from 'src/app/core/interfaces/catalogItem';

@Injectable({
    providedIn: 'root'
})
export class TypeMerchandiseService {


    constructor(
        private http: HttpClient,
        private endpointResources: Endpoints,
    ) { }


    public searchMerchandise(
        textSearch?: string,
        type: MerchandiseCodes = MerchandiseCodes.BASIC_MERCHANDISE,
        hazardousType?: "Y" | "A",
        code?: string
    ): Observable<MerchandiseType[]> {
        const url = environment.urlServerTeclogi + this.endpointResources.searchMerchandise;
        let params = new HttpParams();
        if (textSearch) params = params.append('textSearch', textSearch);
        params = params.append('type', type);
        if (hazardousType) params = params.append('hazardousType', hazardousType);
        if (code) params = params.append('code', code);
        return this.http.get<MerchandiseType[]>(url, { params });
    }

    public getConsignmentPackaging(): Observable<{ catalog: CatalogItem[] }> {
        const url = environment.urlServerTeclogi + this.endpointResources.getConsignmentPackaging;
        return this.http.get<{ catalog: CatalogItem[] }>(url);
    }

    public getConsignmentPackagingMaterials(codePackage: string): Observable<{ id: string, name: string, isDangerous: boolean, codePackage: string }[]> {
        const url = environment.urlServerTeclogi + this.endpointResources.getConsignmentPackagingMaterials;
        return this.http.get<{ id: string, name: string, isDangerous: boolean, codePackage: string }[]>(url, { params: { codePackage } });
    }

}
